<template>

   <spinner v-if="!loaded" ></spinner>

    <div class="template-padding container" v-else-if="loaded"  > 
        
        <div class="row" >
            <div class="col-12 text-left" >
                <router-link :to="{name: 'Facebook Ads Masterclass' }" class="not-active text-left btn btn-transparent border-none btn-sm" > 
                    <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back 
                </router-link>
            </div>
        </div>
        
        <div class="col-12 col-md-10 offset-md-1 p-0 mt-3" >
            <img src="@/assets/images/facebook_ads_masterclass_1200x628-01.png" class="w-100" />
        </div>
        
        <div class="text-justify mt-5 mb-3 h3" style="line-height: 1.5;" >

        </div>
        
        <!-- ACADEMY -->
        <div class="accordion mt-5" role="tablist">
            
            <!-- INTRO -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-0 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        What is copywriting?
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion0" > {{ calculateRead('accordion0') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-0"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion0" >
                        
Before starting to run ads on Facebook, you need to have your offer dialled in. 
<br><br>
That’s because crafting a great offer will allow you to sell a product of value to the right audience.
<br><br>
So before you open Facebook ads Manager, make sure you have the following dialled in:
<br> - The offer
<br> - The audience
<br> - The sales page or funnel
<br><br>
If you don’t have that, make sure to follow our Accelerator course to implement them and proceed afterwards.
<br><br>
Now that you’ve got that implemented, let’s dive in.
<br><br>
So in order to run ads on Facebook, you need to have a Facebook page created and your business verified. 
<br><br>
We’re not gonna cover these in this course, these instructions can be found on Facebook’s documentation or youtube. And they are pretty straight forward.
<br><br>
But before we dive into ads, we first need to talk about digital marketing.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- INTRO -->
            
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-1 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        What is Digital Marketing?
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion1" > {{ calculateRead('accordion1') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-1"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion1">
                        
Digital marketing is the process of integrating digital channels like Facebook, 
Google, and YouTube with marketing techniques such as Pay Per Click (PPC), E- 
mail Marketing, Social Media Marketing, and many others to draw and bring new visitors and turn them into customers.
<br><br>
The whole idea behind this process is to identify and target potential customers 
and interest them with what you are offering, finally convincing them to take action toward your goal.
<br><br>
What is a goal? Well, to put it simply, a goal is whatever you want it to be: either subscribe, opt-in, engage with something, book a call or make a purchase.
<br><br>
And that is usually done through a funnel or a sales page. 
<br><br>
In the good old days, the process was simple: advertise your product, send prospects to a sales page, prospects buy the product. Nowadays, the market is over crowded with ads, different products and offers and people have a lot of options to choose from. And most buyers don’t buy based on their first interaction with your brand.
<br><br>
They need more. Studies shows that people need between 7 to 12 touchpoints in order to make a conversion.
<br><br>
Some are not sure if the product works or if is suited for them, others have price objections, while others just don’t trust you yet.
<br><br>
So in order to convert, they need to go through 3 stages:
<br> - Top Of Funnel ( TOF )
<br> - Middle Of Funnel ( MOF )
<br> - Bottom Of Funnel ( BOF )
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >Top Of the Funnel ( TOF )</h2>
This is the awareness stage. This stage uses multiple digital marketing channels  to boost your brand or product visibility to your targeted audience. 
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >Middle of the Funnel (MOF) </h2>
This is the consideration stage, where your targeted customers are already in the funnel and deciding whether to purchase your product. Their decision depends entirely on various factors, such as your website speed, the prices offered by your competitors, and the shipping fee. 
<br><br>
<br><h2 class="font-size-16 font-weight-bold" >Bottom of the Funnel (BOF) </h2>
This is the final stage or the converting stage. Your potential customers have decided on purchasing your brand or products, and if you guarantee them better offers, discounts, and quick delivery options, your chance of conversion will increase 
and the sale can happen.
<br><br>
In order to have a successful digital marketing campaign, visitors need to go through these stages in order to buy.
<br><br>
Now that you understand the different stages of the funnel, we can talk about Facebook ads and what makes them successful.

                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
        
          </div>
        <!-- ACADEMY -->

        
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
    
export default{
    name: "ACADEMY_sales_page",
    props:["APPKEY"],
    components:{
    },
    data () {
        return {
            loaded: false,
            text: `
              Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
              richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
              brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
              tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
              assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
              wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
              vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
              synth nesciunt you probably haven't heard of them accusamus labore VHS.
            `
        }
    },
    mounted(){
        this.loaded = true;
    },
    methods:{
        openRow(params){
            
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            
            let page = params.row.Icon;
            let ID = params.row.ID;
            
            
            
            
        },
        returnDate(a){
            //return this.$moment.unix(a).format( 'MMM D, HH:mm' )
            return helper.formatDate( a, 'MMM D, HH:mm' )
        },
        
        calculateRead( target ){
            
            //console.log( ev )
            setTimeout( function(){
                
                //console.log( this.$refs )
                //console.log( this.$refs[target].innerHTML )                
                
                let ev = this.$refs[target].innerHTML
                
                const wordsPerMinute = 150; // Average case.
                let result;
                
                let textLength = ev.split(" ").length; // Split by words
                if(textLength > 0){
                    let value = Math.ceil(textLength / wordsPerMinute);
                    result = `~${value} min read`;
                }
                //return result
                //this.$refs[target].appendChild( result )
                document.getElementById(target).innerHTML = result;
                
            }.bind(this), 400 )
                
        }
    },
    computed: {

    },
    created: function () {

    },
    
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/templates/Academy/courses/facebook-ads-masterclass/01.vue